module.exports = __webpack_public_path__ + "static/media/sana_hotels.cb057270.webp";